export default [
  {
    path: "/blpk",
    name: "blpk-home-de",
    component: () => import("./home.vue"),
    meta: {
      requiresVisitor: "blpk",
      customer: "blpk",
      layout: "blpk",
      pageTitle: "blpk",
      linkKey: "customer.nav.home.default",
    },
  },
  {
    path: "/blpk/visitor",
    name: "blpkvisitor",
    component: () => import("./visitor.vue"),
    meta: { 
      visitorKey: "blpk",
      pageTitle: "Live-Stream Basellandschaftliche Pensionskasse", 
      type: "system",
      layout: "blpk",
      customer: "blpk",
      color: "#4d2494"
    },
  },
  {
    path: "/blpk/admin",
    name: "blpk-admin",
    component: () => import("./admin/index.vue"),
    meta: {
      requiresRole: ["moderator", "admin"],
      customer: "blpk",
      layout: "blpk",
      pageTitle: "Admin blpk",
      linkKey: "customer.nav.adminHome",
    },
  },
  {
    path: "/blpk/admin/questions",
    name: "blpk-questions",
    component: () => import("./admin/question-mod.vue"),
    meta: {
      requiresRole: ["moderator", "admin"],
      customer: "blpk",
      layout: "blpk",
      pageTitle: "Admin blpk Questions",
      linkKey: "customer.nav.questionList",
    },
  },
  {
    path: "/blpk/admin/questions/:qtime",
    name: "blpk-questions-filtered",
    component: () => import("./admin/question-mod.vue"),
    meta: {
      requiresRole: ["moderator", "admin"],
      customer: "blpk",
      layout: "blpk",
      pageTitle: "Admin Clinam Questions filtered",
      linkKey: "customer.nav.questionList",
      type: "hidden",
    },
  },
  {
    path: "/blpk/admin/votes",
    name: "blpk-votemod",
    component: () => import("./admin/vote-mod.vue"),
    meta: {
      requiresRole: ["admin"],
      customer: "blpk",
      layout: "blpk",
      pageTitle: "Admin blpk Votes",
      linkKey: "customer.nav.voteList",
    },
  },
];
